// extracted by mini-css-extract-plugin
export default {"mainWrapper":"Home_mainWrapper__t81B0","mainContainer":"Home_mainContainer__07ok7","mainContent":"Home_mainContent__RHVgu"};